module.exports = __webpack_public_path__ + "img/wastebox_blue.min.3be13425.png";